import React, {Component} from 'react';
import Preview from './Preview';
import {Link} from 'react-router-dom';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import FormGuarantee from '../../../../view/FormGuarantee';
import $ from 'jquery';
import converter from 'number-to-words';
import {withRouter} from 'react-router-dom';
import Data from '../../../../data/StateSecretaryCertificateToSell.json';
import Loading from '../../../../view/Loading';
import {Pronoun} from '../../../../model/Helper';
import moment from 'moment';
import RequiredData from '../../../../model/RequiredData';
import FormFinal from '../../../../view/FormFinal';
import Meta from '../../../../model/Meta';

class SecretaryCertificateToSellStep3 extends Component {

	constructor(props) {
		super(props);
		this.state = Data;
	}

	componentWillMount() {

		if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details,
				meetingDate: data.meetingDate
			},			
				()=>{
					RequiredData.property(this.state, this.state.formPath+"/1");
					RequiredData.secretaryCertificate(this.state, this.state.formPath+"/2");
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

	}

	componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	handleChange(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;

	    this.setState({
			destinationEmail: value
		}, ()=>{
			let regex =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if(regex.test(value)) {
				$(".download").addClass("btn-success").prop("disabled", false);
				$(".form-text").addClass("d-none");
			} else {
				$(".download").removeClass("btn-success").prop("disabled", true);
				$(".form-text").removeClass("d-none");
			}
		});
	}

	render() {
		let c = this.state.details.corporation;
		let p = this.state.details.property;

		let blankLine = "____________________";

		let title = "";

		let secretaryMname = (c.secretaryMname) ? " "+c.secretaryMname : "";
		let secretaryLname = (c.secretaryLname) ? " "+c.secretaryLname : "";
		let secretarySuffix = (c.secretarySuffix) ? " "+c.secretarySuffix : "";
		let secretaryName = (c.secretaryFname || c.secretaryMname || c.secretaryLname) ? 
								(c.secretaryFname+secretaryMname+secretaryLname+secretarySuffix): 
								blankLine; 
		let cName = (c.name) ? c.name : blankLine;
		let cAddress = (c.address) ? c.address : blankLine;

		let representativeMname = (c.representativeMname) ? " "+c.representativeMname : "";
		let representativeLname = (c.representativeLname) ? " "+c.representativeLname : "";
		let representativeSuffix = (c.representativeSuffix) ? " "+c.representativeSuffix : "";
		let cRepresentativePosition = (c.representativePosition) ? c.representativePosition : blankLine;
		let cRepresentativeName = (c.representativeFname || c.represemtativeMname || c.representativeLname) ? 
								(c.representativeFname+representativeMname+representativeLname+representativeSuffix): 
								blankLine;
		
		// Set date and date format
		let cBoardMeeting = blankLine;
		if(c.meetingDate) {
			cBoardMeeting = moment(c.meetingDate).format("LL");
		}

		let pAddress = (p.address) ? p.address : blankLine;
		let areaNumber = (typeof parseFloat(p.area) === "number" && parseFloat(p.area)>0) ? Number(p.area).toLocaleString() :
							blankLine;
		let areaText = (typeof parseFloat(p.area) === "number" && parseFloat(p.area)>0) ?
							converter.toWords(p.area) : 
							blankLine;
		let priceNumber = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ? Number(p.price).toLocaleString() :
							blankLine;		
		let priceText = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
							converter.toWords(p.price) : 
							blankLine;

		let contract_html = `
		<style type="text/css">
            @import url("./css/styles.css");
            @import url("./css/styles-custom.css");
        </style>
		<div class="pdf">
			<div class="paper">
				
				<table class="table-even">
					<tr>
						<td>
							<table>
								<tr><td><div class="pr-25">REPUBLIC OF THE PHILIPPINES )</div></td></tr>
								<tr><td><div class="text-right">)S.S.</div></td></tr>
							</table>
						</td>
						<td>
						</td>
					</tr>
				</table>

				<div class="paper-title text-center">
					Secretary Certificate
				</div>
				<div class="">
					<p>
						I, <span class="text-uppercase font-weight-bold dynamic-data secretary-name">${secretaryName}</span>, the undersigned Corporate Secretary of <span class="text-uppercase font-weight-bold dynamic-data">${cName}</span>, a domestic Corporation duly organized and existing under and by virtue of the laws of the Republic of the Philippines, DO HEREBY CERTIFY that in a special meeting of the Board of Directors of said Corporation held at its principal office at <span class="text-capitalize dynamic-data">${cAddress}</span> on ${cBoardMeeting}, duly called for the purpose, a quorum being present and acted throughout, the following resolutions were unanimously adopted, and are now in full force and effect, to wit:
					</p>
				</div>
				<div class="paper-narrow">
					<p>
						“RESOLVED, that the <span class="text-capitalize dynamic-data">${cRepresentativePosition}</span>, <span class="text-uppercase font-weight-bold dynamic-data">${cRepresentativeName}</span>, be authorized to act for and in behalf of the Corporation to SELL, TRANSFER and CONVEY to any interested person or entity who is willing, ready and able to buy, under such terms and conditions ${Pronoun("he", c.secretaryGender, "Natural Person", "secretary")} may deem favorable, a real property owned and registered under the name of the corporation, covered by <span class="font-weight-bold dynamic-data">${title}</span> (hereinafter “Subject Real Property”), located at <span class="text-capitalize dynamic-data address text-capitalize">${pAddress}</span>, with an area of <span class="dynamic-data text-uppercase">${areaText} (${areaNumber})</span> square meters, amounting to <span class="dynamic-data text-uppercase">${priceText}</span> PESOS (P<span class="dynamic-data">${priceNumber}</span>) Philippine Currency;
					</p>
				</div>
				<div class="paper-narrow">
					<p>
						RESOLVED, FURTHER, that the <span class="text-capitalize dynamic-data">${cRepresentativePosition}</span>, in furtherance of and for the implementation of the power and authority granted, be allowed to sign, make, and execute such documents as may be necessary to carry into effect the sale of the Subject Real Property, and to collect full payment and accept the proceeds of the sale in the name of the Corporation, and sign for the receipt thereof; and
					</p>
				</div>
				<div class="paper-narrow">
					<p>
						RESOLVED, FINALLY, that the <span class="text-capitalize dynamic-data">${cRepresentativePosition}</span>, is authorized to do and perform any and all other lawful acts and deeds necessary to undertake the execution and finalization of the sale, transfer or conveyance of the Subject Real Property.”
					</p>
				</div>

				<div>
					<p>
						I FURTHER CERTIFY that the foregoing resolutions are still in effect and have not been amended or modified.
					</p>
				</div>

				<div>
					<p>
						<span class="font-weight-bold">IN WITNESS WHEREOF</span>, I have hereunto set my hand this ____________ at ____________.
					</p>
				</div>

				<div class="my-5 signatory text-right">
					<span class="signatory-inner text-center">
						<span class="signatory-name text-uppercase font-weight-bold dynamic-data">
							${secretaryName}
						</span>
						<br />
						<span class="signatory-position font-italic">
							Corporate Secretary
						</span>
					</span>
					<div class="clearfix"></div>
				</div>

				<div>
					<p>SUBSCRIBED AND SWORN TO before me this on the date and place above written, the affiant exhibiting to me ${Pronoun("his", c.secretaryGender, "Natural Person", "secretary")}  _______________ which is valid until _______________.</p>
				</div>

				<div class="docno mt-5">
					Doc No. ________; <br />
					Page No. _______; <br />
					Book No. _______; <br />
					Series of 20 ___. <br />
				</div>	
			</div>
		</div>
		`;
		
		let fn = "secretary_certificate_to_sell_contracts_ph_"+Date.now()
		let dn = this.state.formName;

		const meta = {
			title: "Your Secretary Certificate to Sell Contract is ready",
			description: "Your FREE custom Secretary Certificate to Sell Contract is now ready for download"
		}

		return(
			<div className="page page-inner page-contract">
				<Meta {...meta}/>
				<Loading />
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">Secretary's Certicate (to Sell)</h4>
								
								<ContractCreate />
								<ProgressBar percentage={Math.floor((3/3)*100)} />

								{/* Final step starts here */}
                                <div className="my-5 text-center">
                                    <FormFinal 
                                        contract_html={contract_html} 
                                        fn={fn} 
                                        dn={dn} 
										formPath={this.state.formPath}
										details={this.state.details} />
                                </div>

								<FormGuarantee />

								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 3/3</p>
									<Link to={this.state.formPath+"/2"} className="btn btn-lightblue mr-2">Go Back and Edit</Link>
								</div>

							</div>
							<div className="col-12 col-md-7 right-preview">
								<Preview {...this.state} />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(SecretaryCertificateToSellStep3);


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/secretary-certificate-to-sell/SecretaryCertificateToSellStep3.js